// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn-primary[data-v-7ec6ddca]{color:#fff;background-color:#0a58ca;border-color:#0a58ca}", ""]);
// Exports
module.exports = exports;
